import { PagingFilter } from '../shared/pagingFilter';

export class DocumentHistoryFilter extends PagingFilter {
  id: number | null;

  searchQuery?: string;

  constructor() {
    super();
  }
}
